
import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { userGroups } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import UserGroupsContent from '../../../components/Dashboard/Subscription/UserGroupsContent'
import { LanguageConsumer } from '../../../LanguageContext'
import { UserGroupProvider } from '../../../UserGroupContext'


const UserGroups = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.UserGroups' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={userGroups.image}
           description={intl.formatMessage({ id: 'Sidebar.Links.UserGroups' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={
                  <UserGroupProvider handleNotificationCall={handleNotificationCall}>
                    <LanguageConsumer>
                      {({ locale }) => (
                        <UserGroupsContent handleNotificationCall={handleNotificationCall} locale={locale}/>
                      )}
                    </LanguageConsumer>
                  </UserGroupProvider>
                }/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default UserGroups

